module.exports = "../dist/frontend/images/about/map.svg?3fab04bd9a5f592b4a0e6b05d90a42f8";